// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"tabs-module--tabContainer--2ze5y","tabTitle":"tabs-module--tabTitle--2LO3i","selected":"tabs-module--selected--PP8t-","fullHeight":"tabs-module--fullHeight--gm4nL"};